document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-media-container--zoomable .product-media__image").forEach(img => {
    const container = img.closest(".product-media-container--zoomable");

    container.addEventListener("mousemove", (e) => {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)";
    });

    container.addEventListener("mouseleave", () => {
      img.style.transform = "scale(1)";
    });
  });
});
